// Analytics consent: "granted" | "denied" | null (not chosen yet). Persisted per browser.
let memoryConsent = null;
const KEY = "af_analytics_consent";
const EVENT = "af-consent-change";
export const OPEN_EVENT = "af-consent-open";

export function getConsent() {
  try {
    const v = JSON.parse(localStorage.getItem(KEY) || "null");
    return memoryConsent || (v && (v.value === "granted" || v.value === "denied") ? v.value : null);
  } catch { return memoryConsent; }
}

export function setConsent(value) {
  if (value !== "granted" && value !== "denied") return;
  memoryConsent = value;
  try { localStorage.setItem(KEY, JSON.stringify({ value, at: new Date().toISOString(), v: 1 })); } catch { /* Keep this session usable when storage is unavailable. */ }
  window.dispatchEvent(new CustomEvent(EVENT, { detail: value }));
}

export const onConsentChange = (fn) => {
  const h = (e) => fn(e.detail);
  window.addEventListener(EVENT, h);
  return () => window.removeEventListener(EVENT, h);
};

export const openConsentSettings = () => window.dispatchEvent(new Event(OPEN_EVENT));
